import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import P2PRegistrationControl from "../P2PRegistrationControl";

const Container = ({ container: { controls = [] }, page, ...props }) => (
    <div className="controls-container">
        {controls.map((control) => (
            <P2PRegistrationControl
                {...props}
                key={control.id}
                controlId={control.id}
                page={page}
                control={control}
            />
        ))}
    </div>
);

Container.propTypes = {
    container: PropTypes.shape({
        controls: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            }),
        ),
    }).isRequired,
    page: PropTypes.string.isRequired,
};

export default Container;
